export default __webpack_public_path__ + "d02cbd19c2192fb6f8a566c5be79f47a.png";